import { render, staticRenderFns } from "./DownloadSample.vue?vue&type=template&id=54877fb9"
import script from "./DownloadSample.vue?vue&type=script&lang=js"
export * from "./DownloadSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports